/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Basic_Patchy_Lobster_CharmInputs */

const fr_basic_patchy_lobster_charm = /** @type {(inputs: Basic_Patchy_Lobster_CharmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date anniversaire du contrat`)
};

/**

* @param {Basic_Patchy_Lobster_CharmInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const basic_patchy_lobster_charm = /** @type {((inputs?: Basic_Patchy_Lobster_CharmInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Basic_Patchy_Lobster_CharmInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_basic_patchy_lobster_charm(inputs)
});